import app from 'flarum/common/app';

app.initializers.add('xypp/flarum-answer-bounty', () => {
  console.log('[xypp/flarum-answer-bounty] Hello, forum and admin!');
});
